var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11699_15004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 3.125C14.0512 3.40181 15.0101 3.95267 15.7787 4.72131C16.5473 5.48994 17.0982 6.44882 17.375 7.5",
    stroke: "#821C6B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 5.625C13.6656 5.97031 14.5297 6.83437 14.875 8.125",
    stroke: "#821C6B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.343 11.3544C13.4295 11.2968 13.5291 11.2617 13.6326 11.2523C13.7362 11.2428 13.8404 11.2594 13.9359 11.3005L17.6203 12.9512C17.7445 13.0043 17.8481 13.0962 17.9157 13.2131C17.9833 13.3299 18.0112 13.4656 17.9953 13.5997C17.8739 14.5067 17.4272 15.3389 16.7383 15.9413C16.0494 16.5437 15.1652 16.8754 14.25 16.8747C11.4321 16.8747 8.72956 15.7553 6.73699 13.7627C4.74442 11.7701 3.625 9.0676 3.625 6.24968C3.6243 5.33452 3.956 4.45026 4.55841 3.76134C5.16082 3.07242 5.99293 2.62574 6.9 2.50436C7.03409 2.48844 7.16973 2.51636 7.28662 2.58396C7.40351 2.65156 7.49537 2.7552 7.54844 2.87936L9.19922 6.56686C9.23978 6.66157 9.25629 6.76484 9.2473 6.86748C9.2383 6.97011 9.20407 7.06893 9.14766 7.15514L7.47813 9.1403C7.4189 9.22966 7.38388 9.33286 7.37649 9.43981C7.36909 9.54676 7.38958 9.6538 7.43594 9.75046C8.08203 11.0731 9.44922 12.4239 10.7758 13.0637C10.873 13.1099 10.9805 13.1299 11.0878 13.1218C11.195 13.1138 11.2983 13.0778 11.3875 13.0176L13.343 11.3544Z",
    stroke: "#821C6B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11699_15004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCall);
export default __webpack_public_path__ + "static/media/ic-call.b83a358200d08b206fca86190cb2cc53.svg";
export { ForwardRef as ReactComponent };